import React, { useState, useEffect } from "react";
import { DPComponentLoader } from "Components/DP";
import UserProfile from "Components/Pages/UserProfile/UserProfile/UserProfile";
import { History } from "history";
import {
  TabLabels,
  TabRoutes,
  UserProfileTabStrings,
} from "Components/Pages/UserProfile/UserProfile/UserProfileTabs";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";

type Props = {
  history: History;
  tab: keyof typeof UserProfileTabStrings;
  id: string;
};

const UserProfileContainer = ({ history, tab, id }: Props) => {
  const [tabIndex, setTabIndex] = useState(
    TabRoutes.includes(tab) ? TabRoutes.indexOf(tab) : 0
  );

  const { loading, userDetails } = useEmployeeProfileQuery();
  const knownTrackingId = userDetails?.employee.knownTrackingId;

  useEffect(() => {
    if (knownTrackingId) {
      AmplitudeProvider.logEvent({
        type: AmplitudeEventType.UserProfilePageViewed,
        payload: { knownTrackingId, tab: UserProfileTabStrings[tab] },
      });
    }
  }, [knownTrackingId, tab]);

  return (
    <DPComponentLoader
      isLoading={loading}
      kind="page"
      awaitComponent={
        <UserProfile
          employeeProfileId={id}
          tabIndex={tabIndex}
          handleChangeTab={(label: string, value: number) => {
            const index = TabLabels.findIndex(tabLabel => tabLabel === label);
            if (index !== -1) {
              const tabRoute = TabRoutes[index];
              history.replace(tabRoute, { prevPath: "/users" });
              setTabIndex(value);
            }
          }}
        />
      }
    />
  );
};

export default UserProfileContainer;
